module.exports = __webpack_public_path__ + "static/media/Subtract02.f6a118f7.svg";